export const selectPhotos = ({photos}) => photos;
export const selectHostGalleryName = (state) => selectPhotos(state).hostGalleryName;
export const selectFeaturedPhoto = (state) => selectPhotos(state).featuredPhoto;
export const selectCombinedPhotos = (state) => {
  const photos = selectPhotos(state);
  return [...(photos.photos || []), ...(photos.hostPhotos || [])];
};
export const selectFailedPhotosCount = (state) => {
  const photos = selectPhotos(state);
  const combinedPhotos = [...(photos.photos || []), ...(photos.hostPhotos || [])];
  return combinedPhotos.filter((photo) => photo.status === 'error').length;
};

export const selectHostUploadProgress = (state) => selectPhotos(state).hostUploadProgress;
export const selectSharedUploadProgress = (state) => selectPhotos(state).sharedUploadProgress;
export const selectHostUploadProcessing = (state) => selectPhotos(state).hostUploadProcessing;
export const selectSharedUploadProcessing = (state) => selectPhotos(state).sharedUploadProcessing;
export const selectPhotoGalleryOpen = (state) => selectPhotos(state).photoGalleryOpen;
export const selectIsHostGalleryEditorOpen = (state) => selectPhotos(state).hostGalleryEditorOpen;
